"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ClayCardAspectRatio = function ClayCardAspectRatio(_ref) {
  var children = _ref.children,
      className = _ref.className,
      containerAspectRatio = _ref.containerAspectRatio;

  var _React$useContext = _react.default.useContext(_Context.default),
      interactive = _React$useContext.interactive;

  var TagName = interactive ? 'span' : 'div';
  return /*#__PURE__*/_react.default.createElement(TagName, {
    className: (0, _classnames.default)(className, 'aspect-ratio', _defineProperty({}, "aspect-ratio-".concat(containerAspectRatio ? containerAspectRatio.replace('/', '-to-') : null), containerAspectRatio))
  }, children);
};

var _default = ClayCardAspectRatio;
exports.default = _default;